import { isBrowser } from 'utils/browser';

const isTouchDevice = () => isBrowser() && 'ontouchstart' in window;

export default isTouchDevice;
